<template>
    <div class="value-chain">
        
        <div class="chain">

            <div class="chain__title">
                {{ data.first_name }}
                <div style="font-size:16px;display:inline-block;">
                    <!--<d-tooltip placement="inline" identifier="index.valuechain" />-->
                </div>
            </div>

            <div class="links">

                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-file-alt fa-fw" />
                            {{ data.offer.count }}
                        </div>
                        tilbud, der afventer afgørelse
                    </div>
                    <div class="coverage">
                        <span class="small">Potentielt DB</span>
                        {{ data.offer.expected_coverage | currency }}
                    </div>
                    <div class="revenue">
                        <span class="small">Potentiel omsætning</span>
                        {{ data.offer.expected_revenue | currency }}
                    </div>
                    <div class="budget" v-if="$auth.user().company.api_provider.slug === 'minuba'">
                        <span class="budget-bar-wrapper">
                            <span class="budget-bar-inner" :style="'width:' + (data.offer.count > 0 ? ((data.offer.has_budget / data.offer.count) * 100) : 0) + '%;'"></span>
                        </span>
                        <span class="small mt-1">{{ data.offer.has_budget }} / {{ data.offer.count }} opgaver har budget</span>
                    </div>
                </div>

                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-inbox-in fa-fw"/>
                            {{ data.open.count }}
                        </div>
                        opgaver, der ikke er påbegyndt
                    </div>
                    <div class="coverage">
                        <span class="small">Forventet DB</span>
                        {{ data.open.expected_coverage | currency }}
                    </div>
                    <div class="revenue">
                        <span class="small">Forventet omsætning</span>
                        {{ data.open.expected_revenue | currency }}
                    </div>
                    <div class="budget" v-if="$auth.user().company.api_provider.slug === 'minuba'">
                        <span class="budget-bar-wrapper">
                            <span class="budget-bar-inner" :style="'width:' + (data.open.count > 0 ? ((data.open.has_budget / data.open.count) * 100) : 0) + '%;'"></span>
                        </span>
                        <span class="small mt-1">{{ data.open.has_budget }} / {{ data.open.count }} opgaver har budget</span>
                    </div>
                </div>
                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-clock fa-fw"/>
                            {{ data.ongoing.count }}
                        </div>
                        igangværende opgaver,
                        <br>
                        der arbejdes på
                    </div>
                    <!--<div class="coverage">
                        <span>
                            <span class="small">Værdi, kostpris</span>
                            {{ data.ongoing.value | currency }}
                        </span>
                    </div>-->
                    <div class="revenue" style="opacity:0;">
                        <span class="small">Placeholder</span>
                        Placeholder
                    </div>
                    <div class="coverage">
                        <span>
                            <span class="small">Værdi, salgspris</span>
                            {{ data.ongoing.value_with_avg_cp | currency }}
                        </span>
                    </div>
                    <div class="budget" v-if="$auth.user().company.api_provider.slug === 'minuba'">
                        <span class="budget-bar-wrapper">
                            <span class="budget-bar-inner" :style="'width:' + (data.ongoing.count > 0 ? ((data.ongoing.has_budget / data.ongoing.count) * 100) : 0) + '%;'"></span>
                        </span>
                        <span class="small mt-1">{{ data.ongoing.has_budget }} / {{ data.ongoing.count }} opgaver har budget</span>
                    </div>
                </div>
                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-check-circle fa-fw"/>
                            {{ data.unbilled.count }}
                        </div>
                        afsluttede opgaver,
                        <br>
                        der ikke er fakturerede
                    </div>
                    <!--<div class="coverage">
                        <span class="small">Værdi, kostpris</span>
                        {{ data.unbilled.value | currency }}
                    </div>-->
                    <div class="revenue" style="opacity:0;">
                        <span class="small">Placeholder</span>
                        Placeholder
                    </div>
                    <div class="coverage">
                        <span class="small">Værdi, salgspris</span>
                        {{ data.unbilled.value_with_avg_cp | currency }}
                    </div>
                    <div class="budget" v-if="$auth.user().company.api_provider.slug === 'minuba'">
                        <span class="budget-bar-wrapper">
                            <span class="budget-bar-inner" :style="'width:' + (data.unbilled.count > 0 ? ((data.unbilled.has_budget / data.unbilled.count) * 100) : 0) + '%;'"></span>
                        </span>
                        <span class="small mt-1">{{ data.unbilled.has_budget }} / {{ data.unbilled.count }} opgaver har budget</span>
                    </div>
                </div>
                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-envelope-open-dollar fa-fw" />
                            {{ data.unpaid_invoices.count }}
                        </div>
                        fakturaer, der endnu ikke er betalt
                    </div>
                    <div class="coverage">
                        <span class="small">Forventet DB</span>
                        {{ data.unpaid_invoices.expected_coverage | currency }}
                    </div>
                    <div class="revenue">
                        <span class="small">Forventet omsætning</span>
                        {{ data.unpaid_invoices.expected_revenue | currency }}
                    </div>
                </div>
                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-calendar-exclamation fa-fw" />
                            {{ data.overdue_invoices.count }}
                        </div>
                        fakturaer med overskredet betaling
                    </div>
                    <div class="coverage">
                        <span class="small">Forventet DB</span>
                        {{ data.overdue_invoices.expected_coverage | currency }}
                    </div>
                    <div class="revenue">
                        <span class="small">Forventet omsætning</span>
                        {{ data.overdue_invoices.expected_revenue | currency }}
                    </div>
                </div>

            </div>

        </div>

        Vælg en af nedenstående bokse og scroll ned på siden for at se de enkelte opgaver/fakturaer
        <br><br>

        <div class="number-overview">
            <div class="row">
                <div class="col-lg-2">
                    <number-card
                        heading="Tilbud"
                        description="der afventer afgørelse"
                        :number="data.offer.count"
                        icon="file-alt"
                        state="avg"
                        :doEmit="true"
                        :selected="selectedTable === 'offer'"
                        @clicked="showTable('offer')"
                        tooltipIdentifier="index.offerProjects"
                    />
                </div>
                <div class="col-lg-2">
                    <number-card
                        heading="Opgaver"
                        description="der endnu ikke er påbegyndt"
                        :number="data.open.count"
                        icon="inbox-in"
                        state="avg"
                        :doEmit="true"
                        :selected="selectedTable === 'open'"
                        @clicked="showTable('open')"
                        tooltipIdentifier="index.openProjects"
                    />
                </div>
                <div class="col-lg-2">
                    <number-card
                        heading="Igangværende opgaver"
                        description="der arbejdes på lige nu"
                        :number="data.ongoing.count"
                        icon="clock"
                        state="bad"
                        :doEmit="true"
                        :selected="selectedTable === 'ongoing'"
                        @clicked="showTable('ongoing')"
                        tooltipIdentifier="index.ongoingProjects"
                    />
                    <br>
                    <number-card
                        heading="Igangværende opgaver"
                        :description="'uden registreringer i ' + $store.state.config.companyMeta.settings.snoozed_days + ' dage '"
                        :number="data.snoozed.count"
                        icon="snooze"
                        state="bad"
                        :doEmit="true"
                        :selected="selectedTable === 'snoozed'"
                        @clicked="showTable('snoozed')"
                        tooltipIdentifier="index.snoozedProjects"
                    />
                    <br>
                    <number-card
                        heading="Reklamationer"
                        description="der ikke er afsluttet"
                        :number="data.claims.count"
                        icon="comment-exclamation"
                        state="good"
                        :doEmit="true"
                        :selected="selectedTable === 'claims'"
                        @clicked="showTable('claims')"
                        tooltipIdentifier="index.openClaims"
                    />
                </div>
                <div class="col-lg-2">
                    <number-card
                        heading="Afsluttede opgaver"
                        description="der ikke er fakturerede"
                        :number="data.unbilled.count"
                        icon="envelope-open-dollar"
                        state="avg"
                        :doEmit="true"
                        :selected="selectedTable === 'noInvoice'"
                        @clicked="showTable('noInvoice')"
                        tooltipIdentifier="index.unbilledProjects"
                    />
                </div>
                <div class="col-lg-2">
                    <number-card
                        heading="Fakturaer"
                        description="der endnu ikke er betalt"
                        :number="data.unpaid_invoices.count"
                        icon="envelope-open-dollar"
                        state="avg"
                        :doEmit="true"
                        :selected="selectedTable === 'unpaid'"
                        @clicked="showTable('unpaid')"
                        tooltipIdentifier="index.unpaidInvoices"
                    />
                </div>
                <div class="col-lg-2">
                    <number-card
                        heading="Fakturaer"
                        :description="'hvor betaling er overskredet med ' + $store.state.config.companyMeta.settings.overdue_days + ' dage'"
                        :number="data.overdue_invoices.count"
                        icon="calendar-exclamation"
                        state="bad"
                        :doEmit="true"
                        :selected="selectedTable === 'exceededPayments'"
                        @clicked="showTable('exceededPayments')"
                        tooltipIdentifier="index.overdueInvoices"
                    />
                </div>
            </div>
        </div>

        <br>

        <!-- TABLES -->
        <div id="tables">
            <table-offer :employeeId="data.relation_id" :employeeName="data.first_name" v-if="selectedTable === 'offer'" @finishedLoading="scrollNow()"></table-offer>
            <table-open :employeeId="data.relation_id" :employeeName="data.first_name" v-if="selectedTable === 'open'" @finishedLoading="scrollNow()"></table-open>
            <table-ongoing :employeeId="data.relation_id" :employeeName="data.first_name" v-if="selectedTable === 'ongoing'" @finishedLoading="scrollNow()"></table-ongoing>
            <table-snoozed :employeeId="data.relation_id" :employeeName="data.first_name" v-if="selectedTable === 'snoozed'" @finishedLoading="scrollNow()"></table-snoozed>
            <table-claims :employeeId="data.relation_id" :employeeName="data.first_name" v-if="selectedTable === 'claims'" @finishedLoading="scrollNow()"></table-claims>
            <table-noinvoice :employeeId="data.relation_id" :employeeName="data.first_name" v-if="selectedTable === 'noInvoice'" @finishedLoading="scrollNow()"></table-noinvoice>
            <table-unpaid :employeeId="data.relation_id" :employeeName="data.first_name" v-if="selectedTable === 'unpaid'" @finishedLoading="scrollNow()"></table-unpaid>
            <table-overdue :employeeId="data.relation_id" :employeeName="data.first_name" v-if="selectedTable === 'exceededPayments'" @finishedLoading="scrollNow()"></table-overdue>
        </div>

    </div>
</template>

<script>
export default {
    data () {
        return {
            selectedTable: null
        }
    },
    props: ['data'],
    methods: {
        scrollNow () {
            const el = document.getElementById('tables')
            const pageElement = document.getElementsByClassName('page')[0]
            setTimeout(() => {
                pageElement.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: el.offsetTop - 125
                })
            }, 500)
        },
        showTable (identifier) {
            this.selectedTable = null
            this.selectedTable = identifier

            // Scroll to table div
            console.log('scroll to table div')
        },
        reset () {
            this.selectedTable = null
        }
    },
    components: {
        'table-offer': require('./tables/offer.vue'),
        'table-open': require('./tables/open.vue'),
        'table-ongoing': require('./tables/ongoing.vue'),
        'table-snoozed': require('./tables/snoozed.vue'),
        'table-claims': require('./tables/claims.vue'),
        'table-noinvoice': require('./tables/noInvoice.vue'),
        'table-unpaid': require('./tables/unpaid.vue'),
        'table-overdue': require('./tables/overdue.vue'),
        'table-exceeded-payments': require('./tables/exceededPayments.vue')
    },
    watch: {
        'data': 'reset'
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/vars.scss";

    .budget {
        margin-top: $margin--small;

        .budget-bar-wrapper {
            display: block;
            width: 100%;
            height: 10px;
            background: #ddd;
            border-radius: 100px;
            overflow: hidden;

            .budget-bar-inner {
                display: block;
                height: 10px;
                width: 0px;
                background: #172b43;
            }
        }
    }

    .chain {
        background: $color--white;
        padding: $padding--main 0;
        // box-shadow: $boxshadow--creative;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: $borderradius--main;
        margin-bottom: $margin--main;
        // grid-column-gap: $margin--small;

        &__title {
            text-align: center;
            margin-bottom: $margin--main * 1.5;
            font-size: $fontsize--large;
            font-weight: 700;
        }

        .links {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
            // align-items: center;
        }

        .link {
            // text-align: center;
            position: relative;
            line-height: 1.5;
            padding: 0 $padding--main;
            font-size: $fontsize--sm;

            &:not(:last-of-type) {
                // border-right: 1px solid rgba(0, 0, 0, 0.05);

                &::before {
                    // content: "\f061";
                    content: "\f356";
                    font-family: "Font Awesome 5 Pro";
                    position: absolute;
                    top: 50%;
                    transform: translate(0, -50%);
                    right: 0;
                    color: $color--green;
                    font-weight: 700;
                    font-size: 24px;
                }
            }

            .name {
                font-size: $fontsize--main * 0.9;
                font-weight: 700;

                .icon {
                    font-size: $fontsize--large;
                    margin-bottom: $margin--small / 2;
                }

                > b {
                    font-weight: 700;
                }

                i {
                    /* font-size: $fontsize--large;
                    margin-bottom: $margin--small / 2; */
                }
            }

            .small {
                font-size: $fontsize--sm;
                display: block;
                font-weight: normal;
                color: $color--dark;
            }

            .revenue {
                font-weight: $fontweight--bold;
                margin-top: $margin--small;
                font-size: $fontsize--main;
                // font-size: $fontsize--medium;
            }

            .coverage {
                font-weight: $fontweight--bold;
                margin-top: $margin--small;
                font-size: $fontsize--medium;
                // color: $color--good;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// responsibleValuechainSingle.vue?ed2bcca0